import React from 'react'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'
import { Divider, RowContainer, Wrapper } from './mixins'

interface InfoCardProps {
  statistic: {
    key: string
    title: string
    label: string
    icon: {
      color: string
      name: string
      size: string
    }
  }
  isLast?: boolean
}

const InfoCard = ({ statistic, isLast }: InfoCardProps) => {
  return (
    <>
      <div>
        <Wrapper>
          <Icon name={statistic.icon.name} size={statistic.icon.size} color={statistic.icon.color} />
          <RowContainer>
            <Text size="md">{statistic.title}</Text>
            <Text size="lg" fontWeight="semibold" variant="secondary">
              {statistic.label}
            </Text>
          </RowContainer>
        </Wrapper>
      </div>
      {!isLast && <Divider />}
    </>
  )
}

export default InfoCard
